import { render, staticRenderFns } from "./MagicLinkAuthForm.vue?vue&type=template&id=12017897&scoped=true"
import script from "./MagicLinkAuthForm.vue?vue&type=script&lang=js"
export * from "./MagicLinkAuthForm.vue?vue&type=script&lang=js"
import style0 from "./MagicLinkAuthForm.vue?vue&type=style&index=0&id=12017897&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12017897",
  null
  
)

export default component.exports